let GOOGLE_CLIENT_ID = "";
let API_BASE_URL = "";

try {
    GOOGLE_CLIENT_ID = process.env.PREACT_APP_GOOGLE_CLIENT_ID || "";
    API_BASE_URL = process.env.PREACT_APP_API_BASE_URL || "";
} catch (error: unknown) {
    console.warn(
        "Pay attention: some of required environment variables are missing"
    );
}

export { GOOGLE_CLIENT_ID, API_BASE_URL };
